<div class="container p-6">
  <span class="texto-grayscale semibold text-titulo">{{ planoSelecionado?.label ?? '' }}</span>
<div class="container-colunas">

  <!-- Coluna 1 -->
  <div class="flex flex-col gap-2">
    <div class="flex flex-col">
      <span class="texto-regular texto-grayscale text-weight-400">UF</span>
      <span class="texto-regular texto-grayscale semibold">{{ localizacaoSelecionada?.estadoSelecionado?.label ?? '-' }}</span>
    </div>
    <div class="flex flex-col">
      <span class="texto-regular texto-grayscale text-weight-400">Município</span>
      <span class="texto-regular texto-grayscale semibold">{{ localizacaoSelecionada?.cidadeSelecionada?.label ?? '-' }}</span>
    </div>
    <div class="flex flex-col" *ngIf="localizacaoSelecionada?.cidadeSelecionada">
      <span class="texto-regular texto-grayscale text-weight-400">Código IBGE</span>
      <span class="texto-regular texto-grayscale semibold">{{ localizacaoSelecionada?.cidadeSelecionada?.value }}</span>
    </div>
  </div>

  <!-- Coluna 2 -->
  <div class="flex flex-col gap-2">
    <div class="flex flex-col">
      <span class="texto-regular texto-grayscale text-weight-400">Dependência administrativa</span>
      <span class="texto-regular texto-grayscale semibold">
        <!-- Quando escola específica: usa dado de dependência administrativa da escola -->
        <ng-container *ngIf="localizacaoSelecionada?.escolaSelecionada">
          {{ dependenciaAdministrativaEscola || '-' }}
        </ng-container>
        <!-- Quando rede/plano: usa tipo de localização -->
        <ng-container *ngIf="!localizacaoSelecionada?.escolaSelecionada">
          {{ localizacaoSelecionada?.cidadeSelecionada ? 'Municipal' :
          localizacaoSelecionada?.estadoSelecionado ? 'Estadual' : 'Federal' }}
        </ng-container>
      </span>
    </div>
    <div class="flex flex-col">
      <!-- Quando escola específica: mostra Localização -->
      <span *ngIf="localizacaoSelecionada?.escolaSelecionada" class="texto-regular texto-grayscale text-weight-400">Localização</span>
      <span *ngIf="localizacaoSelecionada?.escolaSelecionada" class="texto-regular texto-grayscale semibold">{{ areaLocalizacaoEscola || '-' }}</span>

      <!-- Quando rede/plano: mostra Número de escolas -->
      <span *ngIf="!localizacaoSelecionada?.escolaSelecionada" class="texto-regular texto-grayscale text-weight-400">Número de escolas</span>
      <span *ngIf="!localizacaoSelecionada?.escolaSelecionada" class="texto-regular texto-grayscale semibold">{{ getTotalEscolas() | number:'1.0-0' }}</span>
    </div>
  </div>


</div>


  <div class="flex flex-col mt-30 gap-2">
    <span class="texto-grayscale semibold" style="font-size: 24px;line-height: 25.68px;">Matrículas</span>
    <span class="texto-grayscale-800 semibold"
      style="font-size: 18px;line-height: 19.26px;">Etapa/modalidade/segmento</span>
  </div>

  <div class="container-filtros">
    <div class="flex flex-col">
      <div class="flex flex-col mt-15 gap-2">
        <div *ngIf="tipoFiltroSelecionado == '1'; else informacoesPorInstituicao" class="flex flex-col">
          <span *ngIf="resultadoEtapa1 != null" class="texto-ceu semibold text-30">{{resultadoEtapa1.total |
            number}}</span>
          <span class="text-weight-400 texto-grayscale-800 text-16">total de matrículas</span>
        </div>
        <ng-template #informacoesPorInstituicao>
          <div class="flex flex-col">
            <div *ngIf="tipoFiltroSelecionado == '2'" class="flex flex-col">
              <span class="texto-pistache semibold text-30">{{totalMatriculasAreaRural | number}}</span>
              <span class="text-weight-400 texto-grayscale-800 text-16">total de matrículas em área rural</span>
              <span class="texto-pistache text-weight-400 text-16">ou
                {{porcentagemTotalMatriculasAreaRural / 100 | percent:'1.1-1'}}</span>
            </div>
            <div *ngIf="tipoFiltroSelecionado == '3'" class="flex flex-col">
              <span class="texto-cenoura semibold text-30">{{totalMatriculasIntegral | number}}</span>
              <span class="text-weight-400 texto-grayscale-800 text-16">total de matrículas em turno integral</span>
              <span class="texto-cenoura text-weight-400 text-16">ou
                {{porcentagemMatriculasIntegral / 100 | percent:'1.1-1'}}</span>
            </div>
          </div>
        </ng-template>

      </div>
      <div class="flex flex-col mt-15 gap-3">
        <span class="texto-grayscale-800 semibold text-16">Análise</span>
        <mat-radio-group [(ngModel)]="tipoFiltroSelecionado" (ngModelChange)="onSelecaoChange($event)"
          class="flex flex-col gap-3">
          <mat-radio-button class="custom-radio-button" value="1" [checked]="tipoFiltroSelecionado === '1'">total de matrículas por etapa</mat-radio-button>
          <mat-radio-button class="custom-radio-button" *ngIf="instituicaoSelecionada == undefined" value="2">
            matrículas por área de localidade</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div *ngIf="chartOption != undefined" echarts [options]="chartOption" class="chart"
      style="height: 500px; width: 900px;">
    </div>
  </div>

  <!-- Número de turmas -->
  <div class="flex flex-col justify-between mt-30">
    <h1 class="texto-grayscale-900 text-heading-lg text-semibold">
      Número de turmas
    </h1>

    <div class="flex flex-row mt-10 items-center" style="gap: 470px;">
      <div class="flex flex-col">
        <span class="texto-ceu semibold text-30">{{quantidadeTurmasNecessarias | number}}</span>
        <span class="texto-grayscale text-weight-400 text-16" style="width: 90%;">é o número de turmas necessárias em
          {{anoPqr}}</span>
      </div>

      <div class="container-numero-turmas flex flex-col">
        <div class="porcentagem flex flex-col" [ngStyle]="{
          'width': larguraQuantidadeTurmasExistentes + 'px',
          }">
          <div class="flex flex-col">
            <label class="titulo-quantidade-existente titulo-quantidade-existente-numero-turmas texto-pistache-300 text-weight-400">
              {{quantidadeTurmasExistentes | number}}
            </label>

            <div class="div-existente div-existente-numero-turmas relative">
              <div class="container-quantidade-necessarias flex flex-col items-end" [ngStyle]="{
              'width': larguraQuantidadeTurmasNecessarias + 'px',
            }">
                <label
                  class="titulo-necessaria titulo-necessaria-numero-turmas text-weight-400">{{quantidadeTurmasNecessarias
                  | number}}</label>
                <div class="div-necessarias div-necessarias-numero-turmas absolute">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-row mt-6 justify-center gap-8">
          <div class="legenda-existente-turmas flex flex-row gap-1">
            <span style="margin-top: 2px; color: rgba(204, 235, 107, 1); width: 10px;height: 10px;">●</span>
            <span class="texto text-weight-400 texto-grayscale text-16">existentes</span>
          </div>
          <div class="legenda-necessarias-turmas flex flex-row gap-1">
            <span style="margin-top: 2px; color: rgba(54, 185, 250, 1); width: 10px;height: 10px;">●</span>
            <span class="texto text-weight-400 texto-grayscale text-16">necessárias</span>
          </div>
        </div>
        <div class="legenda-numero-turmas p-2">
          <div class="flex flex-col">
            <small style="color: white;">n° turmas</small>
            <div class="flex flex-row gap-1">
              <span style="margin-top: 2px; color: rgba(204, 235, 107, 1); width: 10px;height: 8px;">●</span>
              <span class="text-weight-400 text-16" style="color: white;font-size: 13px;">existentes
                {{quantidadeTurmasExistentes | number}}</span>
            </div>
            <div class="flex flex-row gap-1">
              <span style="margin-top: 2px; color: rgba(54, 185, 250, 1); width: 10px;height: 8px;">●</span>
              <span class="text-weight-400 text-16" style="color: white;font-size: 13px;">necessárias
                {{quantidadeTurmasNecessarias | number}}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="flex flex-col mt-7">
      <div class="flex flex-row">
        <img *ngIf="!numeroTurmasExistentesEhMaior" src="assets/icons/flecha-up.svg"
          class="flecha-up-numero-turmas me-2">
        <img *ngIf="numeroTurmasExistentesEhMaior" src="assets/icons/flecha-down.svg"
          class="flecha-down-numero-turmas me-2">
        <span class="texto-pistache-300 semibold text-30">{{Math.abs(porcentagemInformacaoNumeroTurmas) | percent : '1.1-1'}}</span>
      </div>
      <span *ngIf="numeroTurmasExistentesEhMaior" class="texto-grayscale text-weight-400 text-16">abaixo do número
        existente ({{anoCenso}})</span>
      <span *ngIf="!numeroTurmasExistentesEhMaior" class="texto-grayscale text-weight-400 text-16">acima do número
        existente ({{anoCenso}})</span>
    </div>
  </div>
  <!------------>

  <!-- Numero de docentes -->
  <div class="flex flex-col justify-between mt-30">
    <!-- Título "Profissionais da educação" -->
    <h1 class="texto-grayscale text-semibold text-heading-lg">
      Profissionais da educação
    </h1>

    <h3 class="texto-grayscale-900 text-semibold">
      Número de docentes
    </h3>

    <div class="flex flex-row mt-10 items-center" style="gap: 470px;">
      <div class="flex flex-col">
        <span class="texto-imperial semibold text-30">{{quantidadeDocentesNecessarias | number}}</span>
        <span class="texto-grayscale text-weight-400 text-16" style="width: 85%;">é o número de docentes necessários em
          {{anoPqr}}</span>
      </div>

      <div class="container-numero-docentes flex flex-col">
        <div class="porcentagem flex flex-col" [ngStyle]="{
        'width': larguraQuantidadeDocentesExistentes + 'px',
        }">
          <div class="flex flex-col">
            <label class="titulo-quantidade-existente texto-cenoura text-weight-400">
              {{quantidadeDocentesExistentes | number}}
            </label>

            <div class="div-existente div-existente-numero-docentes relative">
              <div class="container-quantidade-necessarias flex flex-col items-end" [ngStyle]="{
            'width': larguraQuantidadeDocentesNecessarias + 'px',
          }">
                <label class="titulo-necessaria texto-imperial text-weight-400">{{quantidadeDocentesNecessarias |
                  number}}</label>
                <div class="div-necessarias div-necessarias-numero-docentes absolute">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-row mt-6 justify-center gap-8">
          <div class="legenda-existente-docentes flex flex-row gap-1">
            <span style="margin-top: 2px; color: rgba(255, 148, 57, 1); width: 10px;height: 10px;">●</span>
            <span class="texto text-weight-400 texto-grayscale text-16">existentes</span>
          </div>
          <div class="legenda-necessarias-docentes flex flex-row gap-1">
            <span style="margin-top: 2px; color: rgba(255, 43, 55, 1); width: 10px;height: 10px;">●</span>
            <span class="texto text-weight-400 texto-grayscale text-16">necessários</span>
          </div>
        </div>
        <div class="legenda-numero-docentes p-2">
          <div class="flex flex-col">
            <small style="color: white;">n° docentes</small>
            <div class="flex flex-row gap-1">
              <span style="margin-top: 2px; color: rgba(255, 148, 57, 1); width: 10px;height: 8px;">●</span>
              <span class="text-weight-400 text-16" style="color: white;font-size: 13px;">existentes
                {{quantidadeDocentesExistentes | number}}</span>
            </div>
            <div class="flex flex-row gap-1">
              <span style="margin-top: 2px; color: rgba(255, 43, 55, 1); width: 10px;height: 8px;">●</span>
              <span class="text-weight-400 text-16" style="color: white;font-size: 13px;">necessários
                {{quantidadeDocentesNecessarias | number}}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="flex flex-col mt-7">
      <div class="flex flex-row">
        <img *ngIf="!numeroDocentesExistentesEhMaior" src="assets/icons/flecha-up.svg"
          class="flecha-up-numero-docentes me-2">
        <img *ngIf="numeroDocentesExistentesEhMaior" src="assets/icons/flecha-down.svg"
          class="flecha-down-numero-docentes me-2">
        <span class="texto-cenoura semibold text-30">{{Math.abs(porcentagemInformacaoNumeroDocentes) | percent : '1.1-1'}}</span>
      </div>
      <span *ngIf="numeroDocentesExistentesEhMaior" class="texto-grayscale text-weight-400 text-16">abaixo do número
        existente ({{anoCenso}})</span>
      <span *ngIf="!numeroDocentesExistentesEhMaior" class="texto-grayscale text-weight-400 text-16">acima do número
        existente ({{anoCenso}})</span>
    </div>
  </div>
  <!------------>

  <!-- Numero de funcionarios -->
  <div class="flex flex-col justify-between mt-30">
    <h3 class="texto-grayscale-900 text-semibold">
      Número de funcionários
    </h3>

    <div class="flex flex-row mt-10 items-center" style="gap: 470px;">
      <div class="flex flex-col">
        <span class="texto-oceano semibold text-30">{{quantidadeFuncionariosNecessarias | number}}</span>
        <span class="texto-grayscale text-weight-400 text-16" style="width: 85%;">é o número de funcionários
          necessários em {{anoPqr}}</span>
      </div>

      <div class="container-numero-funcionarios flex flex-col">
        <div class="porcentagem flex flex-col" [ngStyle]="{
        'width': larguraQuantidadeFuncionariosExistentes + 'px',
        }">
          <div class="flex flex-col">
            <label class="titulo-quantidade-existente texto-ametista-400 text-weight-400">
              {{quantidadeFuncionariosExistentes | number}}
            </label>

            <div class="div-existente div-existente-numero-funcionarios relative">
              <div class="container-quantidade-necessarias flex flex-col items-end" [ngStyle]="{
            'width': larguraQuantidadeFuncionariosNecessarias + 'px',
          }">
                <label class="titulo-necessaria text-weight-400 texto-oceano">{{quantidadeFuncionariosNecessarias |
                  number}}</label>
                <div class="div-necessarias div-necessarias-numero-funcionarios absolute">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-row mt-6 justify-center gap-8">
          <div class="legenda-existente-funcionarios flex flex-row gap-1">
            <span style="margin-top: 2px; color: rgba(192, 142, 242, 1); width: 10px;height: 10px;">●</span>
            <span class="texto text-weight-400 texto-grayscale text-16">existentes</span>
          </div>
          <div class="legenda-necessarias-docentes flex flex-row gap-1">
            <span style="margin-top: 2px; color: rgba(76, 88, 255, 1); width: 10px;height: 10px;">●</span>
            <span class="texto text-weight-400 texto-grayscale text-16">necessários</span>
          </div>
        </div>
        <div class="legenda-numero-funcionarios p-2">
          <div class="flex flex-col">
            <small style="color: white;">n° funcionários</small>
            <div class="flex flex-row gap-1">
              <span style="margin-top: 2px; color: rgba(192, 142, 242, 1); width: 10px;height: 8px;">●</span>
              <span class="text-weight-400 text-16" style="color: white;font-size: 13px;">existentes
                {{quantidadeFuncionariosExistentes | number}}</span>
            </div>
            <div class="flex flex-row gap-1">
              <span style="margin-top: 2px; color: rgba(76, 88, 255, 1); width: 10px;height: 8px;">●</span>
              <span class="text-weight-400 text-16" style="color: white;font-size: 13px;">necessários
                {{quantidadeFuncionariosNecessarias | number}}</span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="flex flex-col mt-7">
      <div class="flex flex-row">
        <img *ngIf="!numeroFuncionariosExistentesEhMaior" src="assets/icons/flecha-up.svg"
          class="flecha-up-numero-funcionarios me-2">
        <img *ngIf="numeroFuncionariosExistentesEhMaior" src="assets/icons/flecha-down.svg"
          class="flecha-down-numero-funcionarios me-2">
        <span class="texto-ametista-400 semibold text-30">{{Math.abs(porcentagemInformacaoNumeroFuncionarios) | percent : '1.1-1'}}</span>
      </div>
      <span *ngIf="numeroFuncionariosExistentesEhMaior" class="texto-grayscale text-weight-400 text-16">abaixo do número
        existente ({{anoCenso}})</span>
      <span *ngIf="!numeroFuncionariosExistentesEhMaior" class="texto-grayscale text-weight-400 text-16">acima do número
        existente ({{anoCenso}})</span>
    </div>
  </div>
  <!------------>

  <!-- Financiamento -->
  <div class="flex flex-col mt-30">
    <div class="flex flex-col mb-10">
      <h1 class="texto-grayscale-900 text-heading-lg text-regular">
        Financiamento
      </h1>

      <span class="texto-grayscale-900 text-16">
        projetados para {{anoPqr}}
      </span>
    </div>

     <div class="flex flex-row gap-200" *ngIf="!featureFlagService.funcionalidadeHabilitada('1214-alteracoes-valor-aluno')">
      <!-- Coluna esquerda: Valores financeiros -->
      <div class="flex flex-col">
        <!-- ESCOLA ESPECÍFICA: Mostra apenas despesa necessária e CAQ -->
        <div *ngIf="ehEscolaEspecifica" class="flex flex-col gap-5">
          <div class="flex flex-col">
            <span class="texto-ceu semibold text-30">{{parametrosFinanciamentoDto.despesaNecessaria |
              currency:'BRL':'symbol':'1.0-0'}}</span>
            <span class="texto-ceu text-16">despesa necessária</span>
          </div>

          <div class="flex flex-col">
            <span class="texto-grayscale-900 semibold text-18">
              {{tipoFiltroFinanciamentoSelecionado == '1'
                ? (parametrosFinanciamentoDto.valorCaqAno | currency:'BRL':'symbol':'1.0-0')
                : (parametrosFinanciamentoDto.valorCaqMes | currency:'BRL':'symbol':'1.0-0')}}
            </span>
            <span class="texto-grayscale-900 text-16">Valor CAQ ao {{descricaoFiltroFinanciamentoSelecionado}}</span>
          </div>
        </div>

        <!-- REDE/NACIONAL: Mostra todas as métricas -->
        <ng-container *ngIf="!ehEscolaEspecifica">
          <div class="flex flex-col mb-5">
            <span class="texto-ceu semibold text-30">{{parametrosFinanciamentoDto.despesaNecessaria | currency:'BRL':'symbol':'1.0-0'}}</span>
            <span class="texto-ceu text-16">despesa necessária (CAQ, {{anoPqr}})</span>
          </div>

          <div class="flex flex-col mb-5">
            <h3 class="texto-grayscale-900 text-semibold m-0">
              {{parametrosFinanciamentoDto.receitaPotencialMinima | currency:'BRL':'symbol':'1.0-0'}}
            </h3>
            <span class="texto-grayscale-900 text-16">
              receita potencial mínima vinculada (RPEb, {{anoPqr}})
            </span>
          </div>

          <div class="flex flex-col mb-5">
            <h3 class="texto-grayscale-900 text-semibold m-0">
              {{parametrosFinanciamentoDto.despesaRealizada | currency:'BRL':'symbol':'1.0-0'}}
            </h3>
            <span class="texto-grayscale-900 text-16">despesa realizada com educação básica</span>
          </div>

          <div class="flex flex-col">
            <div
              *ngIf="parametrosFinanciamentoDto.porcentagemComplementacao > 0; else semValor"
              class="flex flex-row">
              <img src="assets/icons/flecha-up.svg" class="flecha-down-financiamento me-2" />
              <span class="texto-imperial semibold text-30">{{parametrosFinanciamentoDto.porcentagemComplementacao |
                percent : '1.1-1' }}</span>
            </div>
            <span
              *ngIf="parametrosFinanciamentoDto.porcentagemComplementacao > 0"
              class="texto-grayscale-900 text-16">
              {{parametrosFinanciamentoDto.complementacao | currency: 'BRL':'symbol':'1.0-0'}} para complementação (CAQ,
              {{anoPqr}})
            </span>
            <ng-template #semValor>
              <div class="flex flex-col">
                <span class="texto-imperial semibold text-30">-</span>
                <span class="texto-grayscale-900 text-16">complementação não necessária (CAQ, {{anoPqr}})
                </span>
              </div>
            </ng-template>
          </div>
        </ng-container>
      </div>

      <!-- Coluna direita: Tabela CAQ por etapa (para escola específica) ou estatísticas (para rede/nacional) -->
      <div class="flex flex-col p-2" style="width: 50%;">
        <!-- ESCOLA ESPECÍFICA: Tabela CAQ por etapa -->
        <div *ngIf="ehEscolaEspecifica" class="flex flex-col">
          <div class="flex flex-row justify-between items-center mb-5">
            <span class="texto-grayscale-900 text-18 semibold">
              CAQ ao <span [class]="tipoFiltroFinanciamentoSelecionado == '1' ? 'texto-ceu' : 'texto-imperial'">{{descricaoFiltroFinanciamentoSelecionado}}</span> por etapa
            </span>

            <div class="flex flex-row items-center" id="periodo-financiamento">
              <span class="texto-grayscale-800 semibold text-16 mr-6" style="padding-right: 10px;">Período</span>
              <mat-radio-group [(ngModel)]="tipoFiltroFinanciamentoSelecionado"
                (ngModelChange)="onSelecaoFiltroFinanciamentoChange($event)" class="flex flex-row gap-4">
                <mat-radio-button class="custom-radio-button" value="1" [checked]="tipoFiltroFinanciamentoSelecionado === '1'">ano</mat-radio-button>
                <mat-radio-button class="custom-radio-button" value="2">mês</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>

          <span class="texto-grayscale-900 text-16 mb-3">projetados para {{anoPqr}}</span>

          <!-- Mini tabela CAQ por etapa/modalidade inline -->
          <table class="tabela-financiamento rounded-sm sm-shadow">
            <thead>
              <tr>
                <th scope="col" class="p-3 text-start border-bottom">Etapa/modalidade</th>
                <th scope="col" class="p-3 text-end border-bottom">Parcial (R$)</th>
                <th scope="col" class="p-3 text-end border-bottom">Integral (R$)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let etapa of ['Creche', 'Pré-escola', 'EF - Anos iniciais', 'EF - Anos finais', 'Ensino médio', 'EJA']">
                <td class="p-3 text-start border-bottom">{{etapa}}</td>
                <td class="p-3 text-end border-bottom">
                  <div class="flex flex-row w-full justify-end gap-4 items-center">
                    <div class="relative div-caq-projecao-total-instituicao" style="width: 200px;">
                      <div [style.width.px]="calcularLarguraBarraCaqEtapaSimples(etapa, true)"
                           class="div-caq-projecao-valor"></div>
                    </div>
                    <span class="absolute texto-caq-projecao-valor">
                      {{obterValorCaqEtapaSimples(etapa, true) != null ? (obterValorCaqEtapaSimples(etapa, true) | number:'1.0-0':'pt') : '-'}}
                    </span>
                  </div>
                </td>
                <td class="p-3 text-end border-bottom">
                  <div class="flex flex-row w-full justify-end gap-4 items-center">
                    <div class="relative div-caq-projecao-total-instituicao" style="width: 200px;">
                      <div [style.width.px]="calcularLarguraBarraCaqEtapaSimples(etapa, false)"
                           class="div-caq-projecao-valor-integral"></div>
                    </div>
                    <span class="absolute texto-caq-projecao-valor">
                      {{obterValorCaqEtapaSimples(etapa, false) != null ? (obterValorCaqEtapaSimples(etapa, false) | number:'1.0-0':'pt') : '-'}}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- REDE/NACIONAL: Estatísticas e filtros -->
        <div *ngIf="!ehEscolaEspecifica" class="flex flex-col">
          <div class="flex flex-col gap-1 mb-5">
            <h3 class="texto-grayscale-900 text-semibold m-0">
              Valor-aluno CAQ ao
              <span class="titulo-descricao-filtro-financiamento">{{descricaoFiltroFinanciamentoSelecionado}}</span>
            </h3>

            <div class="flex flex-row justify-between items-center mt-1">
              <span class="texto-grayscale-900 text-16">projetados para {{anoPqr}}</span>

              <div class="flex flex-row items-center mb-5" id="periodo-financiamento">
                <span class="texto-grayscale-800 semibold text-16 mr-6" style="padding-right: 10px;">Período</span>
                <mat-radio-group [(ngModel)]="tipoFiltroFinanciamentoSelecionado"
                  (ngModelChange)="onSelecaoFiltroFinanciamentoChange($event)" class="flex flex-row gap-4">
                  <mat-radio-button class="custom-radio-button" value="1" [checked]="tipoFiltroFinanciamentoSelecionado === '1'">ano</mat-radio-button>
                  <mat-radio-button class="custom-radio-button" value="2">mês</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>

          <!-- Valor-aluno CAQ Estatísticas -->
          <table class="tabela-financiamento">
          <thead>
            <tr>
              <th scope="col" class="p-4 px-7 text-start border-bottom">
                Medida
              </th>
              <th scope="col" class="p-4 text-end border-bottom">
                Valor-aluno CAQ ({{descricaoFiltroFinanciamentoSelecionado}} - R$)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td scope="row" class="text-start p-3 px-7 border-bottom">
                Média
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total">
                    <div [style.width.px]="larguraBarraEstatisticas(dadosEstatisticos.media)" class="div-caq-projecao-valor"></div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">
                     {{ dadosEstatisticos.media | number:'1.0-0':'pt' }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="text-start p-3 px-7 border-bottom">
                Mínimo
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total">
                    <div [style.width.px]="larguraBarraEstatisticas(dadosEstatisticos.minimo)" class="div-caq-projecao-valor"></div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">
                     {{ dadosEstatisticos.minimo | number:'1.0-0':'pt' }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">
                1° quartil
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total">
                    <div [style.width.px]="larguraBarraEstatisticas(dadosEstatisticos.primeiroQuartil)" class="div-caq-projecao-valor"></div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">
                     {{ dadosEstatisticos.primeiroQuartil | number:'1.0-0':'pt' }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">
                Mediana
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total">
                    <div [style.width.px]="larguraBarraEstatisticas(dadosEstatisticos.mediana)" class="div-caq-projecao-valor"></div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">
                     {{ dadosEstatisticos.mediana | number:'1.0-0':'pt' }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">
                3° quartil
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total">
                    <div [style.width.px]="larguraBarraEstatisticas(dadosEstatisticos.terceiroQuartil)" class="div-caq-projecao-valor"></div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">
                     {{ dadosEstatisticos.terceiroQuartil | number:'1.0-0':'pt' }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td class="p-3 px-7 text-start">
                Máximo
              </td>
              <td class="p-3 text-end">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total">
                    <div [style.width.px]="larguraBarraEstatisticas(dadosEstatisticos.maximo)" class="div-caq-projecao-valor"></div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">
                     {{ dadosEstatisticos.maximo | number:'1.0-0':'pt' }}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!------------>
      </div>
    </div>
  </div>
    <div class="flex flex-row gap-200" *ngIf="featureFlagService.funcionalidadeHabilitada('1214-alteracoes-valor-aluno')">
      <!-- Coluna esquerda: Valores financeiros -->
      <div class="flex flex-col">
        <!-- ESCOLA ESPECÍFICA: Mostra apenas despesa necessária e CAQ -->
        <div *ngIf="ehEscolaEspecifica" class="flex flex-col gap-5">
          <div class="flex flex-col">
            <span class="texto-ceu semibold text-30">{{parametrosFinanciamentoDto.despesaNecessaria |
              currency:'BRL':'symbol':'1.0-0'}}</span>
            <span class="texto-ceu text-16">despesa necessária</span>
          </div>

          <div class="flex flex-col">
            <span class="texto-grayscale-900 semibold text-18">
              {{tipoFiltroFinanciamentoSelecionado == '1'
                ? (parametrosFinanciamentoDto.valorCaqAno | currency:'BRL':'symbol':'1.0-0')
                : (parametrosFinanciamentoDto.valorCaqMes | currency:'BRL':'symbol':'1.0-0')}}
            </span>
            <span class="texto-grayscale-900 text-16">Valor CAQ ao {{descricaoFiltroFinanciamentoSelecionado}}</span>
          </div>
        </div>

        <!-- REDE/NACIONAL: Mostra todas as métricas -->
        <ng-container *ngIf="!ehEscolaEspecifica">
          <div class="flex flex-col mb-5">
            <span class="texto-ceu semibold text-30">{{parametrosFinanciamentoDto.despesaNecessaria | currency:'BRL':'symbol':'1.0-0'}}</span>
            <span class="texto-ceu text-16">orçamento da despesa CAQ ({{anoPqr}})</span>
          </div>

          <div class="flex flex-col mb-5">
            <h3 class="texto-grayscale-900 text-semibold m-0">
              {{parametrosFinanciamentoDto.receitaPotencialMinima | currency:'BRL':'symbol':'1.0-0'}}
            </h3>
            <span class="texto-grayscale-900 text-16">
              Receita Potencial mínima Vinculada à Educação ({{anoPqr}})
            </span>
          </div>

          <div *ngIf="!ehEscolaEspecifica" class="flex flex-col mb-5">
            <div
              *ngIf="parametrosFinanciamentoDto.porcentagemComplementacao > 0; else semValor"
              class="flex flex-row">
              <img src="assets/icons/flecha-up.svg" class="flecha-down-financiamento me-2" />
              <span class="texto-imperial semibold text-30">{{parametrosFinanciamentoDto.porcentagemComplementacao |
                percent : '1.1-1' }}</span>
            </div>
            <span
              *ngIf="parametrosFinanciamentoDto.complementacao > 0"
              class="texto-grayscale-900 text-16">
            {{parametrosFinanciamentoDto.complementacao | currency: 'BRL':'symbol':'1.0-0'}} complementação VAAT-CAQ ({{anoPqr}})
          </span>
            <ng-template #semValor>
              <div class="flex flex-col">
                <span class="texto-imperial semibold text-30">-</span>
                <span class="texto-grayscale-900 text-16">complementação VAAT-CAQ não necessária ({{anoPqr}})
              </span>
              </div>
            </ng-template>
          </div>

          <div *ngIf="!ehEscolaEspecifica" class="flex flex-col mb-5">
            <h3 class="texto-grayscale-900 text-semibold m-0">
              {{parametrosFinanciamentoDto.RPEBAposVaatCaq | currency:'BRL':'symbol':'1.0-0'}}
            </h3>

            <span class="texto-grayscale-900 text-16">Receita Potencial mínima Vinculada à Educação após a complementação VAAT-CAQ ({{anoPqr}})</span>
          </div>

          <div *ngIf="!ehEscolaEspecifica" class="flex flex-col mb-5">
            <h3 class="texto-grayscale-900 text-semibold m-0">
              {{parametrosFinanciamentoDto.despesaRealizada | currency:'BRL':'symbol':'1.0-0'}}
            </h3>

            <span class="texto-grayscale-900 text-16">despesa realizada com educação básica (2024)</span>
          </div>
        </ng-container>
      </div>


      <!-- Coluna direita: Tabela CAQ por etapa (para escola específica) ou estatísticas (para rede/nacional) -->
      <div class="flex flex-col p-2" style="width: 50%;">
        <!-- ESCOLA ESPECÍFICA: Tabela CAQ por etapa -->
        <div *ngIf="ehEscolaEspecifica" class="flex flex-col">
          <div class="flex flex-row justify-between items-center mb-5">
            <span class="texto-grayscale-900 text-18 semibold">
              CAQ ao <span [class]="tipoFiltroFinanciamentoSelecionado == '1' ? 'texto-ceu' : 'texto-imperial'">{{descricaoFiltroFinanciamentoSelecionado}}</span> por etapa
            </span>

            <div class="flex flex-row items-center" id="periodo-financiamento">
              <span class="texto-grayscale-800 semibold text-16 mr-6" style="padding-right: 10px;">Período</span>
              <mat-radio-group [(ngModel)]="tipoFiltroFinanciamentoSelecionado"
                (ngModelChange)="onSelecaoFiltroFinanciamentoChange($event)" class="flex flex-row gap-4">
                <mat-radio-button class="custom-radio-button" value="1" [checked]="tipoFiltroFinanciamentoSelecionado === '1'">ano</mat-radio-button>
                <mat-radio-button class="custom-radio-button" value="2">mês</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>

          <span class="texto-grayscale-900 text-16 mb-3">projetados para {{anoPqr}}</span>

          <!-- Mini tabela CAQ por etapa/modalidade inline -->
          <table class="tabela-financiamento rounded-sm sm-shadow">
            <thead>
              <tr>
                <th scope="col" class="p-3 text-start border-bottom">Etapa/modalidade</th>
                <th scope="col" class="p-3 text-end border-bottom">Parcial (R$)</th>
                <th scope="col" class="p-3 text-end border-bottom">Integral (R$)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let etapa of ['Creche', 'Pré-escola', 'EF - Anos iniciais', 'EF - Anos finais', 'Ensino médio', 'EJA']">
                <td class="p-3 text-start border-bottom">{{etapa}}</td>
                <td class="p-3 text-end border-bottom">
                  <div class="flex flex-row w-full justify-end gap-4 items-center">
                    <div class="relative div-caq-projecao-total-instituicao" style="width: 200px;">
                      <div [style.width.px]="calcularLarguraBarraCaqEtapaSimples(etapa, true)"
                           class="div-caq-projecao-valor"></div>
                    </div>
                    <span class="absolute texto-caq-projecao-valor">
                      {{obterValorCaqEtapaSimples(etapa, true) != null ? (obterValorCaqEtapaSimples(etapa, true) | number:'1.0-0':'pt') : '-'}}
                    </span>
                  </div>
                </td>
                <td class="p-3 text-end border-bottom">
                  <div class="flex flex-row w-full justify-end gap-4 items-center">
                    <div class="relative div-caq-projecao-total-instituicao" style="width: 200px;">
                      <div [style.width.px]="calcularLarguraBarraCaqEtapaSimples(etapa, false)"
                           class="div-caq-projecao-valor-integral"></div>
                    </div>
                    <span class="absolute texto-caq-projecao-valor">
                      {{obterValorCaqEtapaSimples(etapa, false) != null ? (obterValorCaqEtapaSimples(etapa, false) | number:'1.0-0':'pt') : '-'}}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- REDE/NACIONAL: Estatísticas e filtros -->
        <div *ngIf="!ehEscolaEspecifica" class="flex flex-col">
          <div class="flex flex-col gap-1 mb-5">
            <h3 class="texto-grayscale-900 text-semibold m-0">
              Valor-aluno após VAAT-CAQ ao
              <span class="titulo-descricao-filtro-financiamento">{{descricaoFiltroFinanciamentoSelecionado}}</span>
            </h3>

            <div class="flex flex-row justify-between items-center mt-1">
              <span class="texto-grayscale-900 text-16">projetados para {{anoPqr}}</span>

              <div class="flex flex-row items-center mb-5" id="periodo-financiamento">
                <span class="texto-grayscale-800 semibold text-16 mr-6" style="padding-right: 10px;">Período</span>
                <mat-radio-group [(ngModel)]="tipoFiltroFinanciamentoSelecionado"
                  (ngModelChange)="onSelecaoFiltroFinanciamentoChange($event)" class="flex flex-row gap-4">
                  <mat-radio-button class="custom-radio-button" value="1" [checked]="tipoFiltroFinanciamentoSelecionado === '1'">ano</mat-radio-button>
                  <mat-radio-button class="custom-radio-button" value="2">mês</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
        <div *ngIf="!ehEscolaEspecifica && (localizacaoSelecionada?.tipoSimulacaoSelecionado === 6 || (localizacaoSelecionada?.tipoSimulacaoSelecionado === 1 && !localizacaoSelecionada?.cidadeSelecionada)); else outraCoisa">
          <!-- Valor-aluno CAQ Estatísticas -->
          <table class="tabela-financiamento">
          <thead>
            <tr>
              <th scope="col" class="p-4 px-7 text-start border-bottom">
                Medida
              </th>
              <th scope="col" class="p-4 text-end border-bottom">
                Valor-aluno após VAAT-CAQ ao ({{descricaoFiltroFinanciamentoSelecionado}} - R$)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td scope="row" class="text-start p-3 px-7 border-bottom">
                Média
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total">
                    <div [style.width.px]="larguraBarraEstatisticas(dadosEstatisticos.media)" class="div-caq-projecao-valor"></div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">
                     {{ dadosEstatisticos.media | number:'1.0-0':'pt' }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="text-start p-3 px-7 border-bottom">
                Mínimo
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total">
                    <div [style.width.px]="larguraBarraEstatisticas(dadosEstatisticos.minimo)" class="div-caq-projecao-valor"></div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">
                     {{ dadosEstatisticos.minimo | number:'1.0-0':'pt' }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">
                1° quartil
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total">
                    <div [style.width.px]="larguraBarraEstatisticas(dadosEstatisticos.primeiroQuartil)" class="div-caq-projecao-valor"></div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">
                     {{ dadosEstatisticos.primeiroQuartil | number:'1.0-0':'pt' }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">
                Mediana
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total">
                    <div [style.width.px]="larguraBarraEstatisticas(dadosEstatisticos.mediana)" class="div-caq-projecao-valor"></div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">
                     {{ dadosEstatisticos.mediana | number:'1.0-0':'pt' }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">
                3° quartil
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total">
                    <div [style.width.px]="larguraBarraEstatisticas(dadosEstatisticos.terceiroQuartil)" class="div-caq-projecao-valor"></div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">
                     {{ dadosEstatisticos.terceiroQuartil | number:'1.0-0':'pt' }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td class="p-3 px-7 text-start">
                Máximo
              </td>
              <td class="p-3 text-end">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total">
                    <div [style.width.px]="larguraBarraEstatisticas(dadosEstatisticos.maximo)" class="div-caq-projecao-valor"></div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">
                     {{ dadosEstatisticos.maximo | number:'1.0-0':'pt' }}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!------------>
      </div>
        </div>
        <ng-template #outraCoisa>
          <div class="flex flex-col items-end text-end">
              <span class="texto-pistache-300 semibold text-5xl" *ngIf="tipoFiltroFinanciamentoSelecionado === '1'">
                {{ parametrosFinanciamentoDto.valorAlunoAnoAposVaatCaq| currency:'BRL':'symbol':'1.0-0' }}
              </span>
            <span class="texto-pistache-300 semibold text-5xl" *ngIf="tipoFiltroFinanciamentoSelecionado === '2'">
                {{ parametrosFinanciamentoDto.valorAlunoMesAposVaatCaq | currency:'BRL':'symbol':'1.0-0' }}
              </span>
          </div>
        </ng-template>
    </div>
  </div>

  <!-- Detalhamento da despesa necessária (#1106) — após a seção Financiamento -->
  <app-tabela-detalhamento-despesa
    *ngIf="mostrarDetalhamentoDespesa"
    [memoria]="memoriaCalculo!">
  </app-tabela-detalhamento-despesa>

  <!-- Adicional para modalidades e contextos (#1105) — após a seção Financiamento -->
  <app-tabela-adicional-modalidade
    *ngIf="mostrarAdicionalModalidade"
    [matriculas]="memoriaCalculo!.resultadoMatriculasFatorPonderacao!"
    [despesa]="memoriaCalculo!.resultadoDistribuicaoDespesaPorEtapa!">
  </app-tabela-adicional-modalidade>

  <!-- Valor por faixa do CAQ -->
  <div class="flex flex-col mt-15" *ngIf="!ehEscolaEspecifica">
    <div class="flex flex-row" style="gap: 330px">
      <div class="flex flex-col">
        <div class="flex flex-col mb-10">
          <h3 class="texto-grayscale text-semibold m-0">
            Valor por faixa do CAQ ao
            <span class="titulo-descricao-filtro-financiamento">{{descricaoFiltroFinanciamentoSelecionado}}</span>
          </h3>
          <span class="texto-grayscale-900 text-16">projetados para {{anoPqr}}</span>
        </div>
        <div class="flex flex-col">
          <span class="texto-ceu semibold text-30">{{getTotalEscolas() | number:'1.0-0' }}</span>
          <span class="texto-grayscale-900 text-16">total de escolas</span>
        </div>
      </div>

      <div class="flex flex-col p-2" style="width: 50%;">
        <div class="flex flex-row justify-end items-center mt-1">
          <div class="flex flex-row items-center mb-5" id="periodo-financiamento">
            <span class="texto-grayscale-800 semibold text-16 mr-6" style="padding-right: 10px;"> Período</span>
            <mat-radio-group [(ngModel)]="tipoFiltroFinanciamentoSelecionado"
              (ngModelChange)="onSelecaoFiltroFinanciamentoChange($event)" class="flex flex-row gap-4">
              <mat-radio-button class="custom-radio-button" value="1" [checked]="tipoFiltroFinanciamentoSelecionado === '1'">ano</mat-radio-button>
              <mat-radio-button class="custom-radio-button" value="2">mês</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <table class="tabela-financiamento">
          <thead>
            <tr>
              <th scope="col" class="p-4 px-7 text-start border-bottom">
                Nível (R$)
              </th>
              <th scope="col" class="p-4 text-end border-bottom">
                <span style="white-space: nowrap">n° escolas</span>
              </th>
              <th scope="col" class="p-4 text-end border-bottom" style="width: 35%;">
                %
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- Faixa 1 -->
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">
                {{getDescricaoFaixaCaq(0)}}
              </td>
              <td class="p-3 text-end border-bottom">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorFaixaCaq(0) | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraPorFaixaCaq(0)" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getPorcentagemPorFaixaCaq(0) | number:'1.1-1'}}</span>
                </div>
              </td>
            </tr>
            <!-- Faixa 2 -->
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">
                {{getDescricaoFaixaCaq(1)}}
              </td>
              <td class="p-3 text-end border-bottom">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorFaixaCaq(1) | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraPorFaixaCaq(1)" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getPorcentagemPorFaixaCaq(1) | number:'1.1-1'}}</span>
                </div>
              </td>
            </tr>
            <!-- Faixa 3 -->
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">
                {{getDescricaoFaixaCaq(2)}}
              </td>
              <td class="p-3 text-end border-bottom">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorFaixaCaq(2) | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraPorFaixaCaq(2)" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getPorcentagemPorFaixaCaq(2) | number:'1.1-1'}}</span>
                </div>
              </td>
            </tr>
            <!-- Faixa 4 -->
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">
                {{getDescricaoFaixaCaq(3)}}
              </td>
              <td class="p-3 text-end border-bottom">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorFaixaCaq(3) | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraPorFaixaCaq(3)" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getPorcentagemPorFaixaCaq(3) | number:'1.1-1'}}</span>
                </div>
              </td>
            </tr>
            <!-- Faixa 5 -->
            <tr>
              <td scope="row" class="p-3 px-7 text-start">
                {{getDescricaoFaixaCaq(4)}}
              </td>
              <td class="p-3 text-end">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorFaixaCaq(4) | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraPorFaixaCaq(4)" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getPorcentagemPorFaixaCaq(4) | number:'1.1-1'}}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!------------>

  <!-- Valor do caq por area de localidade -->
  <div class="flex flex-col mt-15" *ngIf="!ehEscolaEspecifica">
    <div class="flex flex-row" style="gap: 206px">
      <div class="flex flex-col">
        <div class="flex flex-col mb-10">
          <h3 class="texto-grayscale text-semibold m-0">
            Valor CAQ ao
            <span class="titulo-descricao-filtro-financiamento">{{descricaoFiltroFinanciamentoSelecionado}}</span>
            por área de localidade
          </h3>

          <span class="texto-grayscale-900 text-16">projetados para {{anoPqr}}</span>
        </div>
        <div class="flex flex-col">
          <span class="texto-ceu semibold text-30">{{getTotalEscolas() | number:'1.0-0' }}</span>
          <span class="texto-grayscale-900 text-16">total de escolas</span>
        </div>
      </div>
      <div class="flex flex-col p-2" style="width: 50%;">
        <div class="flex flex-row justify-end items-center mt-1">
          <div class="flex flex-row items-center mb-5" id="periodo-financiamento">
            <span class="texto-grayscale-800 semibold text-16 mr-6" style="padding-right: 10px;"> Período</span>
            <mat-radio-group [(ngModel)]="tipoFiltroFinanciamentoSelecionado"
              (ngModelChange)="onSelecaoFiltroFinanciamentoChange($event)" class="flex flex-row gap-4">
              <mat-radio-button class="custom-radio-button" value="1" [checked]="tipoFiltroFinanciamentoSelecionado === '1'">ano</mat-radio-button>
              <mat-radio-button class="custom-radio-button" value="2">mês</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <table class="tabela-financiamento">
          <thead>
            <tr>
              <th scope="col" class="p-4 px-7 text-start border-bottom">
                Área da localidade
              </th>
              <th scope="col" class="p-4 text-end border-bottom">
                <span style="white-space: nowrap">n° escolas</span>
              </th>
              <th scope="col" class="p-4 text-end border-bottom" style="width: 35%;">
                Valor CAQ {{descricaoFiltroFinanciamentoSelecionado}} (média - R$)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">Urbana</td>
              <td class="p-3 text-end border-bottom">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorLocalizacaoDiferenciada('Urbana') | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraCaqPorLocalizacaoDiferenciada('Urbana')" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getMediaCaqPorLocalizacaoDiferenciada('Urbana') !== null ? (getMediaCaqPorLocalizacaoDiferenciada('Urbana') | number:'1.0-0':'pt') : '-'}}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start">Campo</td>
              <td class="p-3 text-end">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorLocalizacaoDiferenciada('Campo') | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraCaqPorLocalizacaoDiferenciada('Campo')" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getMediaCaqPorLocalizacaoDiferenciada('Campo') !== null ? (getMediaCaqPorLocalizacaoDiferenciada('Campo') | number:'1.0-0':'pt') : '-'}}</span>
                </div>
              </td>
            </tr>
            <ng-container>
              <tr *ngFor="let locDifDesc of ['Terra Indígena', 'Comunidade Quilombola']; ">
                <td scope="row" class="p-3 px-7 text-start border-top">{{ locDifDesc }}</td>

                <td class="p-3 text-end border-top">
                  <span class="texto-grayscale-900 text-14">
                    {{ getEscolasPorLocalizacaoDiferenciada(locDifDesc) | number:'1.0-0':'pt' }}
                  </span>
                </td>

                <td class="p-3 text-end border-top">
                  <div class="flex flex-row w-full justify-end gap-4 items-center">
                    <div class="relative div-caq-projecao-total-instituicao">
                      <div
                        class="div-caq-projecao-valor"
                        [style.width.px]="getLarguraBarraCaqPorLocalizacaoDiferenciada(locDifDesc)">
                      </div>
                    </div>

                    <span class="absolute texto-caq-projecao-valor">
                    {{
                        getMediaCaqPorLocalizacaoDiferenciada(locDifDesc) !== null
                          ? (getMediaCaqPorLocalizacaoDiferenciada(locDifDesc) | number:'1.0-0':'pt')
                          : '-'
                      }}
                    </span>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Valor CAQ por porte da escola -->
  <div class="flex flex-col mt-15" *ngIf="!ehEscolaEspecifica">
    <div class="flex flex-row" style="gap: 330px">
      <div class="flex flex-col">
        <div class="flex flex-col mb-10">
          <h3 class="texto-grayscale text-semibold m-0">
            Valor CAQ ao
            <span class="titulo-descricao-filtro-financiamento">{{descricaoFiltroFinanciamentoSelecionado}}</span>
            por porte da escola
          </h3>
          <span class="texto-grayscale-900 text-16">projetados para {{anoPqr}}</span>
        </div>
        <div class="flex flex-col">
          <span class="texto-ceu semibold text-30">{{getTotalEscolas() | number:'1.0-0' }}</span>
          <span class="texto-grayscale-900 text-16">total de escolas</span>
        </div>
      </div>

      <div class="flex flex-col p-2" style="width: 50%;">
        <div class="flex flex-row justify-end items-center mt-1">
          <div class="flex flex-row items-center mb-5" id="periodo-financiamento-porte">
            <span class="texto-grayscale-800 semibold text-16 mr-6" style="padding-right: 10px;"> Período</span>
            <mat-radio-group [(ngModel)]="tipoFiltroFinanciamentoSelecionado"
              (ngModelChange)="onSelecaoFiltroFinanciamentoChange($event)" class="flex flex-row gap-4">
              <mat-radio-button class="custom-radio-button" value="1" [checked]="tipoFiltroFinanciamentoSelecionado === '1'">ano</mat-radio-button>
              <mat-radio-button class="custom-radio-button" value="2">mês</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <table class="tabela-financiamento">
          <thead>
            <tr>
              <th scope="col" class="p-4 px-7 text-start border-bottom">
                Porte escola (nº matrículas)
              </th>
              <th scope="col" class="p-4 text-end border-bottom">
                <span style="white-space: nowrap">nº escolas</span>
              </th>
              <th scope="col" class="p-4 text-end border-bottom" style="width: 35%;">
                Valor CAQ {{descricaoFiltroFinanciamentoSelecionado}} (média - R$)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">{{getDescricaoFaixaPorte(0)}}</td>
              <td class="p-3 text-end border-bottom">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorFaixaPorte(0) | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraCaqPorFaixaPorte(0)" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getMediaCaqPorFaixaPorte(0) != null ? (getMediaCaqPorFaixaPorte(0) | number:'1.0-0':'pt') : '-'}}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">{{getDescricaoFaixaPorte(1)}}</td>
              <td class="p-3 text-end border-bottom">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorFaixaPorte(1) | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraCaqPorFaixaPorte(1)" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getMediaCaqPorFaixaPorte(1) != null ? (getMediaCaqPorFaixaPorte(1) | number:'1.0-0':'pt') : '-'}}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">{{getDescricaoFaixaPorte(2)}}</td>
              <td class="p-3 text-end border-bottom">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorFaixaPorte(2) | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraCaqPorFaixaPorte(2)" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getMediaCaqPorFaixaPorte(2) != null ? (getMediaCaqPorFaixaPorte(2) | number:'1.0-0':'pt') : '-'}}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">{{getDescricaoFaixaPorte(3)}}</td>
              <td class="p-3 text-end border-bottom">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorFaixaPorte(3) | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraCaqPorFaixaPorte(3)" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getMediaCaqPorFaixaPorte(3) != null ? (getMediaCaqPorFaixaPorte(3) | number:'1.0-0':'pt') : '-'}}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">{{getDescricaoFaixaPorte(4)}}</td>
              <td class="p-3 text-end border-bottom">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorFaixaPorte(4) | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraCaqPorFaixaPorte(4)" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getMediaCaqPorFaixaPorte(4) != null ? (getMediaCaqPorFaixaPorte(4) | number:'1.0-0':'pt') : '-'}}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">{{getDescricaoFaixaPorte(5)}}</td>
              <td class="p-3 text-end border-bottom">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorFaixaPorte(5) | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraCaqPorFaixaPorte(5)" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getMediaCaqPorFaixaPorte(5) != null ? (getMediaCaqPorFaixaPorte(5) | number:'1.0-0':'pt') : '-'}}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">{{getDescricaoFaixaPorte(6)}}</td>
              <td class="p-3 text-end border-bottom">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorFaixaPorte(6) | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraCaqPorFaixaPorte(6)" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getMediaCaqPorFaixaPorte(6) != null ? (getMediaCaqPorFaixaPorte(6) | number:'1.0-0':'pt') : '-'}}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start border-bottom">{{getDescricaoFaixaPorte(7)}}</td>
              <td class="p-3 text-end border-bottom">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorFaixaPorte(7) | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end border-bottom">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraCaqPorFaixaPorte(7)" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getMediaCaqPorFaixaPorte(7) != null ? (getMediaCaqPorFaixaPorte(7) | number:'1.0-0':'pt') : '-'}}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="p-3 px-7 text-start">{{getDescricaoFaixaPorte(8)}}</td>
              <td class="p-3 text-end">
                <span class="texto-grayscale-900 text-14">{{getEscolasPorFaixaPorte(8) | number:'1.0-0':'pt'}}</span>
              </td>
              <td class="p-3 text-end">
                <div class="flex flex-row w-full justify-end gap-4 items-center">
                  <div class="relative div-caq-projecao-total-instituicao">
                    <div [style.width.px]="getLarguraBarraCaqPorFaixaPorte(8)" class="div-caq-projecao-valor">
                    </div>
                  </div>
                  <span class="absolute texto-caq-projecao-valor">{{getMediaCaqPorFaixaPorte(8) != null ? (getMediaCaqPorFaixaPorte(8) | number:'1.0-0':'pt') : '-'}}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Custo aluno-qualidade por etapa - Oculto para escola específica (já está no financiamento) -->
  <div *ngIf="!ehEscolaEspecifica" class="flex flex-col mt-15">
    <span class="texto-grayscale semibold text-18 mb-5">
      Custo-Aluno Qualidade (CAQ) ao
      <span [class]="tipoFiltroFinanciamentoSelecionado === '1' ? 'texto-ceu' : 'texto-imperial'">{{descricaoFiltroFinanciamentoSelecionado}}</span> por etapa
    </span>

    <div class="flex flex-col p-2">
      <div class="flex flex-row justify-end items-center mt-1 mb-10">
        <div class="flex flex-row items-center mb-5" id="periodo-financiamento">
          <div style="margin-right: 8px">
            <app-menu-suspenso
              (chamadaDeAcao)="chamarAcao($event)" [opcoes]="opcoesFiltroLocalizacao">
             {{ this.filtroLocalizacaoEscolhido.rotulo }}
            </app-menu-suspenso>
          </div>
          <span class="texto-grayscale-800 semibold text-16 mr-6" style="padding-right: 10px;">Período</span>
          <mat-radio-group [(ngModel)]="tipoFiltroFinanciamentoSelecionado"
            (ngModelChange)="onSelecaoFiltroFinanciamentoChange($event)" class="flex flex-row gap-4">
            <mat-radio-button class="custom-radio-button" value="1" [checked]="tipoFiltroFinanciamentoSelecionado === '1'">ano</mat-radio-button>
            <mat-radio-button class="custom-radio-button" value="2">mês</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div style="width: 100%; display: flex; justify-content: end">
        <relatorio-caq-por-mes-ano-por-etapa
        [filtroLocalizacaoEscolhido]="this.filtroLocalizacaoEscolhido"
        [tipoFiltroFinanciamentoSelecionado]="tipoFiltroFinanciamentoSelecionado"
        [descricaoFiltroFinanciamentoSelecionado]="descricaoFiltroFinanciamentoSelecionado"
        [dadosRelatorioCaq]="this.dadosRelatorioCaq"
        ></relatorio-caq-por-mes-ano-por-etapa>
      </div>
    </div>
  </div>

  <!-- Detalhamento de Infraestrutura (R4 - Novas Salas e Prédios) -->
  <div class="mt-10" *ngIf="featureFlagService.funcionalidadeHabilitada('novas-salas')">
    <div class="subtitulo mb-4">
      <p class="text-blue-500 text-heading-lg text-bold m-0">
        Detalhamento de Infraestrutura (Novas Salas e Prédios)
      </p>
    </div>
    <div class="table-content rounded-sm sm-shadow p-4">
      <app-tabela [cabecalhoCustomizado]="true" ngSkipHydration>
        <ng-container cabecalho>
          <tr>
            <th class="top-left-header text-body-lg align-start">Etapa/Modalidade</th>
            <th class="top-header text-body-lg align-start">Tipo de construção</th>
            <th class="top-header text-body-lg align-start">Tamanho m²</th>
            <th class="top-header text-body-lg align-end">Área localidade</th>
            <th class="top-header text-body-lg align-start">nº</th>
            <th class="top-header text-body-lg align-start" style="width: 20%;">%</th>
            <th class="top-right-header text-body-lg align-start">Despesa de capital (R$)</th>
          </tr>
        </ng-container>
        <ng-container corpo>
          <tr *ngFor="let linha of dadosRelatorioCaq?.detalhamentoInfraestrutura; let i = index">
            <!-- Colunas agrupadas (Rowspan) - Aparecem apenas na linha par (Urbana) -->
            <td *ngIf="i % 2 === 0" [attr.rowspan]="2" style="vertical-align: middle; border-right: 1px solid #e0e0e0;">{{ linha.etapaModalidade }}</td>
            <td *ngIf="i % 2 === 0" [attr.rowspan]="2" style="vertical-align: middle; border-right: 1px solid #e0e0e0;">{{ linha.tipoConstrucao }}</td>
            <td *ngIf="i % 2 === 0" [attr.rowspan]="2" style="vertical-align: middle; border-right: 1px solid #e0e0e0;">{{ linha.tamanhoM2 | number:'1.0-2' }}</td>

            <!-- Colunas Individuais -->
            <td class="text-body-lg align-end align-middle">{{ linha.areaLocalidade }}</td>
            <td style="vertical-align: middle;">{{ linha.quantidade }}</td>
            <td style="vertical-align: middle;">
              <div class="flex flex-row w-full items-center gap-4">
                <div class="relative div-caq-projecao-total-instituicao">
                  <div [style.width.%]="linha.percentual" class="div-caq-projecao-valor"></div>
                </div>
                <span class="texto-caq-projecao-valor">{{ linha.percentual | number:'1.1-1' }}</span>
              </div>
            </td>
            <td style="vertical-align: middle;">{{ linha.custoTotal | number:'1.0-0' }}</td>
          </tr>
          <tr class="bold">
            <td colspan="6" style="text-align: center;">Total</td>
            <td>{{ dadosRelatorioCaq?.financiamentoConstrucaoCustoTotalNovosPredios | number:'1.0-0' }}</td>
          </tr>
        </ng-container>
      </app-tabela>
    </div>
  </div>

  <!-- Salas de aula: diagnóstico e projeção (#1472) — última tabela do relatório -->
  <div class="mt-15" *ngIf="mostrarTabelaSalasDeAula">
    <app-tabela-salas-de-aula
      [salasExistentes]="memoriaCalculo!.resultadoParte9_2ResultadoSalasExistentes"
      [salasNecessarias]="memoriaCalculo!.resultadoParte9_3ResultadoSalasNecessarias"
      [demandaNovasSalas]="memoriaCalculo!.resultadoParte9_4DemandaPorNovasSalas"
      [carregandoPdf]="carregandoPdfSalasDeAula"
      (pdfClick)="baixarPdfSalasDeAula()">
    </app-tabela-salas-de-aula>
  </div>
  </div>
</div>
